import React, { useState } from "react";

import { AIMenuListProps } from "./types.js";

import { AICommandPanel } from "../../features/panels/AICommandPanel/AICommandPanel.js";

export const AIMenuList = React.forwardRef((props: AIMenuListProps, ref) => {
  const [userPrompt, setUserPrompt] = useState("");

  if (!props.items.length) {
    return null;
  }

  return (
    <>
      <AICommandPanel
        editor={props?.editor as any}
        onOpenChange={() => {}}
        userPrompt={userPrompt}
        items={props?.items}
        ref={ref}
      />
    </>
  );
});

AIMenuList.displayName = "AIMenuList";

export default AIMenuList;
